import { useQuery } from "@tanstack/react-query"
import type { CertificateType } from "@tfg/db"

import { getCertificateTypeParamsValidationType } from "@tfg/types/schemas/certificates"

import { httpClient } from "~/backend/axios.ts"

export const useListCertificateTypesQuery = (
  params?: getCertificateTypeParamsValidationType
) =>
  useQuery({
    queryKey: ["listCertificateTypes"],
    queryFn: async () => {
      const res = await httpClient.get<CertificateType[]>(
        `certificates/types`,
        {
          params,
        }
      )
      return res.data
    },
  })
